<div class="view-quiz-container" [formGroup]="quizzesForm">
  <div class="title">Complete the quiz to continue your learning journey!</div>
  <div class="quiz" formArrayName="questions">
    <div class="question">
      {{ quiz?.questions[activeIndex].question }}
    </div>
    <div class="options">
      <div
        class="option"
        *ngFor="
          let option of quiz?.questions[activeIndex]?.options;
          let j = index
        "
      >
        <div class="radio-btn" [ngClass]="{ disabled: quizSubmitted }">
          <input
            type="radio"
            [value]="option"
            [name]="activeIndex"
            [formControl]="quizzesForm.get('questions')['controls'][activeIndex].get('chosenAnswer')"
            (click)="onClickRadioBtn(option)"
          />
        </div>
        <div class="input-box">
          {{ option }}
          <span
            class="tick-icon"
            style="margin-left: 1rem"
            *ngIf="
              quizSubmitted &&
              option ==
                quizzesForm
                  .get('questions')
                  ['controls'].at(this.activeIndex)
                  .get('correctAnswer')?.value
            "
          >
            <i class="fa-solid fa-check" style="color: green"></i>
          </span>
          <span
            class="wrong-icon"
            style="margin-left: 1rem"
            *ngIf="
              quizSubmitted &&
              option ==
                quizzesForm
                  .get('questions')
                  ['controls'].at(this.activeIndex)
                  .get('chosenAnswer')?.value &&
              quizzesForm
                .get('questions')
                ['controls'].at(this.activeIndex)
                .get('chosenAnswer')?.value !=
                quizzesForm
                  .get('questions')
                  ['controls'].at(this.activeIndex)
                  .get('correctAnswer')?.value
            "
          >
            <i class="fa-solid fa-xmark" style="color: red"></i>
          </span>
        </div>
      </div>
    </div>
  </div>
  <div class="back-next-btn">
    <div class="back-btn">
      <button *ngIf="activeIndex > 0" (click)="onClickBack()">
        <i class="fas fa-angle-left"></i>
      </button>
    </div>
    <div class="next-btn">
      <button
        *ngIf="activeIndex < this.quiz.questions.length - 1"
        (click)="onClickNext()"
        [ngClass]="{
          'disabled-btn':
            quizzesForm
              .get('questions')
              ['controls'].at(this.activeIndex)
              .get('chosenAnswer').value == ''
        }"
      >
        <i class="fas fa-angle-right"></i>
      </button>
      <button
        *ngIf="activeIndex == this.quiz.questions.length - 1 && !quizSubmitted"
        [ngClass]="{
          'disabled-btn':
            quizzesForm
              .get('questions')
              ['controls'].at(this.activeIndex)
              .get('chosenAnswer').value == ''
        }"
        (click)="onClickSubmit()"
      >
        Submit
      </button>
    </div>
  </div>
</div>
